import JSEncrypt from 'jsencrypt';

const PUB_KEY = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKQAv9wZG/IMfb+OIuTujeRb9YAalLRIo7bGy7LdBNtcPas+d+PF56tzH3rZATU6TsCEU44npuydabvq9uwCUWECAwEAAQ==';

export function rsaEncrypt(str) {
  var crypt = new JSEncrypt();
  crypt.setPublicKey(PUB_KEY);
  return crypt.encrypt(str);
}
